module.exports = __webpack_public_path__ + "img/img-b272e4e4.66874f9e.png";